import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
// import HeaderLogo from './header-logo'

const Header = ({ siteTitle }) => (
  <div
    style={{
      background: '#26734d',
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: '99999',
    }}
  >
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '1rem 1.0875rem',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <h1 style={{ margin: 0, fontSize: '0.8rem' }}>
        {/* <HeaderLogo /> */}
        <Link
          to="/"
          style={{
            color: 'white',
            textDecoration: 'none',
          }}
        >
          {siteTitle + ' Horticulture'}
        </Link>
      </h1>
      <Link
        to="/horticulture/contact"
        style={{ fontSize: '0.8rem', color: 'white', textDecoration: 'none' }}
      >
        Contact
      </Link>
    </div>
  </div>
);

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: '',
};

export default Header;
